(() => {
  document.documentElement.classList.add('sv-js');

  // Reveal on scroll. Content is visible without JS; IntersectionObserver only adds the entrance.
  const reveal = () => {
    const els = document.querySelectorAll('.sv-rv:not(.is-in)');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el, i) => { el.style.transitionDelay = `${Math.min(i % 4, 3) * 70}ms`; io.observe(el); });
    setTimeout(() => document.querySelectorAll('.sv-rv:not(.is-in)').forEach((el) => el.classList.add('is-in')), 2500);
  };

  // Rail arrow buttons.
  const rails = () => {
    document.querySelectorAll('[data-sv-rail]').forEach((sec) => {
      const track = sec.querySelector('.sv-rail');
      if (!track || sec.dataset.svBound) return;
      sec.dataset.svBound = '1';
      sec.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = track.firstElementChild;
          const step = card ? card.offsetWidth + 20 : 300;
          track.scrollBy({ left: Number(btn.dataset.dir) * step * 2, behavior: 'smooth' });
        });
      });
    });
  };

  // Category tabs on the bestseller grid.
  const tabs = () => {
    document.querySelectorAll('[data-sv-tabs]').forEach((sec) => {
      if (sec.dataset.svBound) return;
      sec.dataset.svBound = '1';
      const btns = sec.querySelectorAll('[data-filter]');
      btns.forEach((b) => b.addEventListener('click', () => {
        btns.forEach((x) => x.setAttribute('aria-selected', String(x === b)));
        const f = b.dataset.filter;
        sec.querySelectorAll('.sv-card').forEach((c) => {
          c.hidden = f !== 'all' && c.dataset.tab !== f;
          c.classList.add('is-in');
        });
      }));
    });
  };

  // Copy-to-clipboard coupon chips (event delegation so it survives re-renders).
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-copy]');
    if (!chip) return;
    const code = chip.dataset.copy;
    const done = () => { chip.classList.add('is-copied'); chip.textContent = 'Copied'; setTimeout(() => { chip.classList.remove('is-copied'); chip.textContent = code; }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  const boot = () => { reveal(); rails(); tabs(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
